import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuditLog } from 'src/app/shared/models/AuditLog';

interface FieldChange {
  field: string;
  label: string;
  before: any;
  after: any;
}

@Component({
  selector: 'app-audit-detail-dialog',
  templateUrl: './audit-detail-dialog.component.html',
  styleUrl: './audit-detail-dialog.component.less'
})
export class AuditDetailDialogComponent {

  changes: FieldChange[] = [];

  // ── Labels pour tous les entityType gérés ────────────────────────────────
  private fieldLabels: Record<string, string | null> = {
    // ── COMMUN ───────────────────────────────────────────────────────────────
    id:                   null,
    version:              null,
    createdAt:            null,
    updatedAt:            null,

    // ── FEB ──────────────────────────────────────────────────────────────────
    febId:                           null,
    febNumber:                       'N° FEB',
    febLabel:                        'Label de la FEB',
    fibLabel:                        'Label de la FEB',
    febStatut:                       'Statut FEB',
    febPcSncf:                       'PC SNCF fourni',
    febDateDemande:                  'Date de la demande',
    febDateDemarrage:                'Date de démarrage',
    febDateFinPrevisionnelle:        'Date fin prévisionnelle',
    febDuree:                        'Durée d\'intervention',
    febNomenclature:                 'Nomenclature',
    febPresenceSiteSncf:             'Présence site SNCF',
    febProvisionDeplacementAstreinte:'Provision déplacement & astreinte',
    febContexteObjectifProjet:       'Contexte et objectif',
    febDescriptionBesoin:            'Description du besoin',
    febNbAnneesExperiences:          'Années d\'expérience',
    febCompetencesFonctionnelles:    'Compétences fonctionnelles',
    febCompetencesTechniques:        'Compétences techniques',
    febEnvironnementTechnique:       'Environnement technique',
    febSavoirEtreQualites:           'Savoir-être et qualités',
    febPilotLotId:                   null,
    febPilotLotNom:                  'Pilote de lot',
    febDemandeurId:                  null,
    febDemandeurNom:                 'Demandeur',
    febEntiteSncfId:                 null,
    febEntiteSncfNom:                'Entité SNCF',
    febDivisionDemandeurId:          null,
    febDivisionDemandeurNom:         'Division du demandeur',
    febProjectId:                    null,
    febProjectNom:                   'Projet',
    febLocalisationId:               null,
    febLocalisationLabel:            'Localisation',
    febUoActivitePressentiId:        null,
    febUoActivitePressentiLabel:     'Activité UO',
    febCreatedById:                  null,
    febCreatedByNom:                 'Créé par',
    // Activités FEB
    label:                           'Label activité',
    pourcentage:                     'Répartition (%)',
    activiteFibId:                   null,

    // ── DEVIS ─────────────────────────────────────────────────────────────────
    devisId:                         null,
    devisCreatedAt:                  null,
    devisUpdatedAt:                  null,
    devisReference:                  'N° Devis',
    devisStatut:                     'Statut',
    devisMontantTotal:               'Montant total',
    devisPrixUoPropose:              'Prix UO proposé',
    devisPrixUoGrille:               'Prix UO grille',
    devisDuree:                      'Durée prévisionnelle',
    devisProvisionFrais:             'Provision frais',
    devisDateDemarrageGo:            'Date démarrage GO',
    devisDateFinTravaux:             'Date fin travaux',
    dateEntretien:                   'Date d\'entretien',
    devisDateEntretien:              'Date d\'entretien',
    devisNumeroBdc:                  'N° BDC',
    devisNomContrat:                 'Nom du contrat',
    devisNumeroContrat:              'N° Contrat',
    devisCommentaire:                'Commentaire CDC',
    devisMajore:                     'Prestation majorée',
    devisMotifRefus:                 'Motif de refus',
    devisMotifRetourArriere:         'Motif retour en arrière',
    devisBeneficiaire:               'Bénéficiaire',
    demandId:                        null,
    febPrixUoGrille:                 null,
    febPrixUoGrilleMajore:           null,

    // ── DEMAND ────────────────────────────────────────────────────────────────
    state:                           'Statut',
    cost:                            'Montant (€)',
    load:                            'Charge (j)',
    reference:                       'N° Bon de commande',
    description:                     'Désignation',
    serviceType:                     'Service',
    prestationType:                  'Type de prestation',
    facturationMode:                 'Mode de facturation',
    reductionCost:                   'Réduction',
    deliveryDate:                    'Date de livraison réelle',
    revisedDeliveryDate:             'Date de livraison revue',
    realizationDateTime:             'Date de réalisation (GO)',
    estimateQuoteDate:               'Date prévisionnelle devis',
    applicationName:                 'Application',
    demandNumber:                    'N° Demande',
    year:                            'Année',
    jiraReference:                   'Référence Jira',
    galileiProjectCode:              'Code projet Galéi',
    galileiProjectDescription:       'Libellé projet Galéi',
    galileiProjectActivityCode:      'Code activité Galéi',
    galileiProjectActivityDescription:'Libellé activité Galéi',
    creationDateTime:                null,
    userRecorder:                    null,
    userResponsable:                 null,
    project:                         null,
    pack:                            null,
    orderForm:                       null,
    functionalReference:             null,
    comments:                        null,

    // ── ECHEANCE (sous-champs) ────────────────────────────────────────────────
    status:                          'Statut échéance',
    delayedCost:                     'Coût reporté',
    projected:                       'Projeté',
    date:                            null,
  };

  // Libellés des statuts
  private statutLabels: Record<string, string> = {
    // FEB
    CREEE:      'Créée', EN_ATTENTE: 'En attente',
    VALIDEE:    'Validée', ARCHIVEE: 'Archivée',
    // Devis
    CREE:       'Créé', ACCEPTE: 'Accepté',
    REFUSE:     'Refusé', ARCHIVE: 'Archivé',
    // Demand
    CHIFFRE:    'Chiffré', ENGAGE: 'Engagé',
    ENGAGE_APPROUVE: 'Engagé / Approuvé',
    LIVRE:      'Livré', FERME: 'Fermé', ANNULE: 'Annulé',
    // Echeance
    DEFAULT:                    'Par défaut',
    EN_ATTENTE_VALIDATION_CDS:  'En attente validation CDS',
    EN_ATTENTE_VALIDATION_SNCF: 'En attente validation SNCF',
    VALIDE_SNCF:                'Validé SNCF',
  };

  // Libellés des opérations
  private operationLabels: Record<string, string> = {
    CREATE: 'Création', UPDATE: 'Modification', DELETE: 'Suppression'
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { audit: AuditLog; changes: any[] },
    public dialogRef: MatDialogRef<AuditDetailDialogComponent>
  ) {
    this.changes = this.buildChanges(data.changes);
  }

  get operationLabel(): string {
    return this.operationLabels[this.data.audit.operation] ?? this.data.audit.operation;
  }

  private buildChanges(raw: any[]): FieldChange[] {
    if (!raw || raw.length === 0) return [];
    return raw
      .map(c => {
        const label = this.humanizeField(c.field ?? c.label ?? '');
        if (label === null) return null;
        return {
          field:  c.field ?? '',
          label,
          before: this.formatValue(c.field ?? '', c.before),
          after:  this.formatValue(c.field ?? '', c.after),
        };
      })
      .filter((c): c is FieldChange => c !== null);
  }

get entityIcon(): string {
  switch (this.data.audit.entityType) {
    case 'DEVIS':   return 'receipt_long';
    case 'FEB':     return 'assignment';
    case 'DEMAND':  return 'task';
    default:        return 'manage_search';
  }
}


  private humanizeField(field: string): string | null {
    if (!field) return null;

    // Champ connu directement
    if (Object.prototype.hasOwnProperty.call(this.fieldLabels, field)) {
      return this.fieldLabels[field] as string | null;
    }

    // Activités FEB : febActivites[0].label
    const actMatch = field.match(/^febActivites\[(\d+)\]\.(.+)$/);
    if (actMatch) {
      const index    = parseInt(actMatch[1]) + 1;
      const subField = actMatch[2];
      const subLabel = this.fieldLabels[subField];
      if (subLabel === null) return null;
      return `Activité ${index} — ${subLabel ?? subField}`;
    }

    // Échéances : echeances[id=xxx].status
    const echeanceIdMatch = field.match(/^echeances\[id=([^\]]+)\]\.(.+)$/);
    if (echeanceIdMatch) {
      const subField = echeanceIdMatch[2];
      const subLabel = this.fieldLabels[subField];
      if (subLabel === null) return null;
      return `Échéance — ${subLabel ?? subField}`;
    }

    // Échéances par index : echeances[0].status
    const echeanceIdxMatch = field.match(/^echeances\[(\d+)\]\.(.+)$/);
    if (echeanceIdxMatch) {
      const index    = parseInt(echeanceIdxMatch[1]) + 1;
      const subField = echeanceIdxMatch[2];
      const subLabel = this.fieldLabels[subField];
      if (subLabel === null) return null;
      return `Échéance ${index} — ${subLabel ?? subField}`;
    }

    // Champ avec [id=xxx].champ
    const idMatch = field.match(/\[id=[^\]]+\]\.(.+)$/);
    if (idMatch) {
      const subField = idMatch[1];
      const subLabel = this.fieldLabels[subField];
      if (subLabel === null) return null;
      return subLabel ?? subField;
    }

    // Champ avec point : prend la feuille
    const dotIdx = field.lastIndexOf('.');
    if (dotIdx !== -1) {
      const leaf = field.substring(dotIdx + 1);
      const leafLabel = this.fieldLabels[leaf];
      if (leafLabel === null) return null;
      return leafLabel ?? leaf;
    }

    return field;
  }

  private formatValue(field: string, value: any): any {
    if (value === null || value === undefined || value === '') return '—';

    // Statuts
    if (['state', 'devisStatut', 'febStatut', 'status'].includes(field)) {
      if (typeof value === 'string') return this.statutLabels[value] ?? value;
    }

    // Booléens
    if (typeof value === 'boolean') return value ? 'Oui' : 'Non';
    if (value === 'true')  return 'Oui';
    if (value === 'false') return 'Non';

    // Montants
    if (['cost', 'devisMontantTotal', 'devisPrixUoPropose', 'devisProvisionFrais',
         'devisPrixUoGrille', 'reductionCost', 'delayedCost',
         'febProvisionDeplacementAstreinte'].includes(field)) {
      const n = Number(value);
      if (!isNaN(n)) return n.toLocaleString('fr-FR', { minimumFractionDigits: 2 }) + ' €';
    }

    // Durées / charges
    if (['load', 'febDuree', 'devisDuree'].includes(field)) {
      const n = Number(value);
      if (!isNaN(n)) return n + ' j';
    }

    // Pourcentage
    if (field === 'pourcentage' || field.includes('pourcentage')) {
      const n = Number(value);
      if (!isNaN(n)) return n + ' %';
    }

    // Dates ISO
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
      const d = new Date(value);
      if (!isNaN(d.getTime())) return d.toLocaleDateString('fr-FR');
    }

    return value;
  }
}